import { Component, Input, Inject, ViewChild, ElementRef } from '@angular/core';

import { Subscription } from 'rxjs';

import { ActionKeys } from '../../../Forms/enums/keys.enum';
import { SortOrderServiceInterface } from '../../../../Common/Misc/services/sort-order.service.interface';
import { SortOrderEnum } from '../../../../api/shared/enums/sort-order.enum';

@Component({
    selector: 'agpr-sort-order',
    templateUrl: './sort-order.component.html',
    styleUrls: ['./sort-order.component.scss'],
    standalone: false
})
export class SortOrderComponent {

    @Input() id: string = null;
    @Input() isDisabled: boolean = false;
    @Input() tooltip: string;

    @Input() optionKey: string;
    @Input() optionLabel: string;

    @ViewChild('trigger') trigger: ElementRef;
    @ViewChild('listbox') listbox: ElementRef;

    readonly ascendingSortOrderIcon: string = 'fa-regular fa-arrow-down-short-wide';
    readonly descendingSortOrderIcon: string = 'fa-regular fa-arrow-up-wide-short';

    selectedSortField: string;
    sortByOptions: any[] = [];
    subscriptions: Subscription[] = [];
    sortOrderDropdownDisplay: boolean = false;

    sortOrderIcon: string = this.ascendingSortOrderIcon;
    sortOrder: SortOrderEnum;

    constructor(
        @Inject('SortOrderServiceInterface') private serviceInterface: SortOrderServiceInterface
    ) {
        this.subscriptions.push(
            this.serviceInterface.getSortableFields().subscribe(fields =>  {
                this.sortByOptions = fields;
            }),
            this.serviceInterface.getSortOrder().subscribe(order => this.setSortOrder(order)),
            this.serviceInterface.getSortField().subscribe(field => this.selectedSortField = field)
        );
    }

    get hasDropdown(): boolean {
        return (this.sortByOptions?.length ?? 0) > 1;
    }

    closeSortOptionDropdown() {
        this.sortOrderDropdownDisplay = false;
    }

    sortOrderDropdownClick() {
        this.sortOrderDropdownDisplay = !this.sortOrderDropdownDisplay;
        if (this.sortOrderDropdownDisplay) {
            requestAnimationFrame(() => {
                (document.querySelector('li.agpr-sortOrder-dropdownPanelItem--selected') as HTMLElement)?.focus();
            });
        } else {
            this.trigger.nativeElement.focus();
        }
    }

    toggleSortOrder(): void {
        if (this.sortOrder === SortOrderEnum.ascending) {
            this.serviceInterface.setSortOrder(SortOrderEnum.descending);
        } else {
            this.serviceInterface.setSortOrder(SortOrderEnum.ascending);
        }
    }

    setSortOrder(value: SortOrderEnum) {
        this.sortOrder = value;
        this.sortOrderIcon = value === SortOrderEnum.descending ? this.descendingSortOrderIcon : this.ascendingSortOrderIcon;
    }


    selectSortField(value: any, event?: any) {
        if (event instanceof KeyboardEvent && !(event.key === ActionKeys.ENTER || event.key === ActionKeys.SPACE)) {
            return;
        }
        this.serviceInterface.setSortField(value);
        this.sortOrderDropdownClick();
    }

    onTriggerKeydown(event: KeyboardEvent): void {
        if (event.key === ActionKeys.DOWN && !this.sortOrderDropdownDisplay) {
            this.sortOrderDropdownClick();
        }
    }

    onOptionKeydown(event: KeyboardEvent, index: number): void {
        if (index > -1) {
            this.selectSortField(this.sortByOptions[index], event);
        }
        if (event.key === ActionKeys.UP && index === 0 || event.key === ActionKeys.ENTER || event.key === ActionKeys.TAB || event.key === ActionKeys.ESCAPE) {
            this.sortOrderDropdownClick();
        }
    }
}

